import React from 'react';

import {
  AccommodationItemsFragment,
  useAccommodationQuery,
  useCreateAccommodationItemMutation,
  useDeleteAccommodationItemMutation,
  useUpdateAccommodationItemMutation,
} from '../../../generated/graphql';
import deletePageItem from '../../../helpers/apolloCache/deletePageItem';
import { useManageItem } from '../../../helpers/useManageItem';
import Layout from '../../FormComponents/Layout';
import { pagesQuery } from '../../LeftContainer/graphql';
import { PageItemProps } from '../BasicItem';
import { createSave } from '../BusinessItem/Edit';
import { initialValues, validationSchema } from '../BusinessItem/Form';
import RoomBlockDetails from './RoomBlockDetails';

const FIELDS = [
  'address',
  'description',
  'email',
  'phone',
  'website',
  'checkInDate',
  'checkOutDate',
  'guestCode',
  'rate',
];

export const AccommodationItem: React.FC<PageItemProps> = ({ onSaveHandler }) => {
  const { pageId, itemId, isNew, close } = useManageItem();

  const [update, { loading: updating }] = useUpdateAccommodationItemMutation();
  const [create, { loading: creating }] = useCreateAccommodationItemMutation();
  const [destroy, { loading: deleting }] = useDeleteAccommodationItemMutation();

  const { data, loading } = useAccommodationQuery({
    variables: {
      pageId,
      id: itemId!,
    },
    skip: isNew,
  });

  const item = data?.page?.accommodationItem;
  const save = createSave({ update, create, pageId, itemId, close, onSaveHandler, fields: FIELDS });

  const onDelete = async () => {
    if (itemId) {
      await destroy({
        variables: {
          attributes: {
            id: itemId,
            pageId,
          },
        },
        update(cache) {
          deletePageItem({ cache, pageId, itemId });
        },
        refetchQueries: [{ query: pagesQuery }],
      });
    }
  };

  const hiddenFields = item?.provider === 'engine' ? ['website'] : [];

  return (
    <Layout
      headerText={`${isNew ? 'Add' : 'Update'} a Place to Stay`}
      validationSchema={validationSchema}
      initialValues={initialValues<AccommodationItemsFragment>(item)}
      hiddenFields={hiddenFields}
      onSubmit={save}
      Component={RoomBlockDetails}
      loading={loading}
      updating={updating || creating || deleting}
      close={close}
      pageId={pageId}
      isNew={isNew}
      onDelete={onDelete}
    />
  );
};
